<template>
    <Modal
        :show="showComponentModal"
        :showContent="showContent"
        :title="modalTitle"
        :closeBtn="closeBtn"
        @close="onCloseModal"
        :position="position"
        :size="size"
        :fullHeight="fullHeight"
        class="cemetery-panel-wrapper">
        <template v-slot:content="{ }">
            <div :class="[{'d-flex flex-column flex-fill': fullHeight}, 'ct-aside-control-item']">
				<div :class="[{'d-flex flex-column flex-fill': fullHeight}, 'ct-aside-control-body p-0']">
                    <transition name="fade" mode="out-in">
                        <component
                            v-if="componentView"
                            v-bind:is="componentView"
                            :value="componentData"
                            :additional="componentDataAdditional"
                            :params="componentParams"
                            :moduleCode="moduleCode"
                            :mapId="mapId"
                            :panelCfg="panel"
                            :parentId="idPanel"
                            :baseTranslateID="componentTranslateID"
                            />
                    </transition>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script>
import PanelMapMixin from './mixins/PanelMapMixin';
import { EVENTS } from '../../shared/config/event-constants';
import { formatUrl, isFunction, isArray, isObject } from "@config/utils";


export default {
    mixins: [
        PanelMapMixin,
    ],
    components: {
        Modal: () => import(/* webpackChunkName: "modal-data" */ '@/app/shared/components/modals/ModalData'),
        CemeteryView: () => import(/* webpackChunkName: "cemeteries-cemeteryview" */ './views/CemeteryView'),
        SectorsView: () => import(/* webpackChunkName: "cemeteries-sectorsview" */ './views/SectorsView'),
        OccupationView: () => import(/* webpackChunkName: "cemeteries-occupationview" */ './views/OccupationView'),
    },
    props: {
        position: {
            type: String,
            default: 'left'
        },
        size: {
            type: String,
            default: 'small',
        },
        mapId: {
            type: String,
            default: null,
        },
        fullHeight: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            idPanel: 'cemetery',
            showContent: true,
            callback: null,
            form: {
                componentKey: null,
                componentView: null,
                componentData: {},
                componentDataAdditional: {},
                componentFeature: null,
                componentTranslateID: null,
                componentParams: {},
            },
            componentEvents: [
                {
                    key: 'cemetery',
                    events: {
                        show: {
                            type: EVENTS.SHOW_MODAL_READ_CEMETERY,
                            fn: (params) => this.onOpenModal('cemetery', 'CemeteryView', 'cemeteries', params)
                        },
                        close: {
                            type: EVENTS.CLOSE_MODAL_READ_CEMETERY,
                            fn: (params) => this.onCloseModal('cemetery', 'CemeteryView', 'cemeteries', params)
                        },
                        closed: {
                            type: EVENTS.CLOSED_MODAL_READ_CEMETERY,
                        },
                        closedDetail: [
                            {
                                type: EVENTS.CLOSED_MODAL_DETAIL_CEMETERY,
                                fn: (params) => this.onCloseModalDetail('cemetery', params)
                            },
                        ],
                    }
                },
                {
                    key: 'sectors',
                    events: {
                        show: {
                            type: EVENTS.SHOW_MODAL_SECTORS,
                            fn: (params) => this.onOpenModal('sectors', 'SectorsView', 'sectors', params)
                        },
                        close: {
                            type: EVENTS.CLOSE_MODAL_SECTORS,
                            fn: (params) => this.onCloseModal('sectors', 'SectorsView', 'sectors', params)
                        },
                        closed: {
                            type: EVENTS.CLOSED_MODAL_SECTORS,
                        },
                        closedDetail: [
                            {
                                type: EVENTS.CLOSED_MODAL_DETAIL_SECTOR,
                                fn: (params) => this.onCloseModalDetail('sectors', params)
                            },
                        ],
                    }
                },
                {
                    key: 'occupation',
                    events: {
                        show: {
                            type: EVENTS.SHOW_MODAL_READ_OCCUPATION,
                            fn: (params) => this.onOpenModal('occupation', 'OccupationView', 'occupations', params)
                        },
                        close: {
                            type: EVENTS.CLOSE_MODAL_READ_OCCUPATION,
                            fn: (params) => this.onCloseModal('occupation', 'OccupationView', 'occupations', params)
                        },
                        closed: {
                            type: EVENTS.CLOSED_MODAL_READ_OCCUPATION,
                        },
                        closedDetail: [
                            {
                                type: EVENTS.CLOSED_MODAL_DETAIL_OCCUPATION,
                                fn: (params) => this.onCloseModalDetail('occupation', params)
                            },
                            {
                                type: EVENTS.CLOSED_MODAL_DETAIL_INTERMENT,
                                fn: (params) => this.onCloseModalIntermentDetail('occupation', params)
                            },
                            {
                                type: EVENTS.CLOSED_MODAL_DETAIL_DEED_OWNER,
                                fn: (params) => this.onCloseModalDeedOwnerDetail('occupation', params)
                            }
                        ],
                    }
                },
            ]
        }
    },
    created() {
        this.setEvents(true);
    },
    beforeDestroy() {
        this.setEvents(false);
    },
    computed: {
        componentKey() {
            return this.form.componentKey;
        },
        componentView() {
            return this.form.componentView;
        },
        componentData() {
            return this.form.componentData;
        },
        componentDataAdditional() {
            return this.form.componentDataAdditional;
        },
        componentTranslateID() {
            return this.form.componentTranslateID;
        },
        componentParams() {
            return this.form.componentParams;
        },
        showComponentModal() {
            return !!this.componentView;
        }
    },
    methods: {
        setEvents(flag, types = ['show', 'close', 'closedDetail']) {
            this.reset();
            this.componentEvents.forEach(obj => {
                let events = obj.events;
                Object.keys(events ?? {}).forEach(key => {
                    if(types.includes(key)) {
                        let evtConfigs = events[key];
                        if(!isArray(evtConfigs)) {
                            evtConfigs = [evtConfigs];
                        }
                        evtConfigs.forEach(evtConfig => {
                            if(evtConfig.type && evtConfig.fn) {
                                this.$eventBus[flag ? 'listen' : 'remove'](this.moduleCode, evtConfig.type, evtConfig.fn);
                            }
                        })
                    }
                });
            });
        },
        reset() {
            Object.assign(this.$data.form, this.$options.data().form);
            // this.callback = null;
            // this.idPanel = null;
        },
        onOpenModal(type, view, translateID, params = {}) {
            this.setComponent(type, view, translateID, params);
        },
        onCloseModal(params) {
            let obj = this.componentEvents.find(obj => obj.key == this.componentKey);
            if(obj && obj.events.closed) {
                this.$eventBus.publish(this.moduleCode, obj.events.closed.type, {
                    key: this.componentKey,
                    data: this.componentData,
                    feature: this.form.componentFeature
                });
            }

            if(this.callback && isFunction(this.callback)) {
                this.callback({...this.componentData});
            }
            this.reset();
        },

        onCloseModalIntermentDetail(type, params) {
            this.onCloseModalDetail(type, {...params, ...{data: {id: params?.data?.occupation_id}}});
        },
        onCloseModalDeedOwnerDetail(type, params) {
            this.onCloseModalDetail(type, {...params, ...{data: {id: params?.data?.occupation_id}}});
        },
        onCloseModalDetail(type, params) {
            const {action, ...rest} = params;
            switch (action) {
                case EVENTS.CREATED:
                case EVENTS.UPDATED:
                case EVENTS.DELETED:
                    this.reloadData({type, ...rest});
                    break;
                default:
                    break;
            }
        },
        setComponent(type, view, translateID, params = {}) {
            const {data = {}, feature, event, callback, ...rest} = params;
            this.idPanel = type;
            this.callback = callback;
            this.$set(this.form, 'componentParams', {
                feature,
                event,
                ...rest
            });

            this.loadComponentData(data)
            .then(res => {
                if(res) {
                    const {data, ...additional} = res;
                    this.form.componentKey = type;
                    this.form.componentView = view;
                    // this.$set(this.form, 'componentData', data);
                    // this.$set(this.form, 'componentDataAdditional', additional);
                    this.form.componentData = isObject(data) ? Object.freeze(data) : data;
                    this.form.componentDataAdditional = isObject(additional) ? Object.freeze(additional) : additional;
                    this.form.componentFeature = feature;
                    this.form.componentTranslateID = translateID;
                }else{
                    this.onCloseModal();
                }
            });
        },
        async loadComponentData(params) {
            let url = this.panelUrl?.show;
            if(url) {
                return await this.$http.get(formatUrl(url, params))
                .then(({data}) => {
                    return data;
                })
                .catch(error => {
                    this.showHttpError(error);
                })
            }
            return Promise.resolve(null);
        },
        reloadData(params) {
            const {type, data={}} = params;
            if(type == this.componentKey) {
                if(data.id && this.componentData?.id == data.id || data.code && this.componentData?.code == data.code || isArray(this.componentData)) {
                    this.onOpenModal(this.componentKey, this.componentView, this.componentTranslateID, {data});
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped>
</style>